import React, { useContext, useState } from 'react'
import { CaretDownFilled, CaretRightFilled } from '@fluentui/react-icons'
import styles from './CoursesList.module.css'
import ChatHistoryList from '../ChatHistory/ChatHistoryList'
import { SidebarContext } from '../../contexts/SidebarContextProps'
import { Course } from '@/models'
import { GLOBAL_COURSE_CODE_NAMES } from '@/constants/globalCourseNames'
import { groupCoursesBySemester, getGlobalCourses, formatCourseDisplayName } from '@/utils/courseGrouping'
const CoursesList = () => {
    const sidebarContext = useContext(SidebarContext)
    const [expandedCourse, setExpandedCourse] = useState<string | null>(null)

    const handleSelectionChange = (courseName: string) => {
        sidebarContext.setSelectedCourse(courseName)
        setExpandedCourse(courseName)
        if (sidebarContext.selectedCourse !== courseName) {
            sidebarContext.setSelectedConversation(null)
        }
    }
    const handleCaretClick = (courseName: string) => {
        if (sidebarContext.selectedConversation === null) {
            console.log('selectedConversation is null')
        }
        if (expandedCourse === courseName) {
            setExpandedCourse(null)
        } else {
            handleSelectionChange(courseName)
        }
    }

    const globalCourses = getGlobalCourses(sidebarContext.courses, GLOBAL_COURSE_CODE_NAMES)
    const groupedCourses = groupCoursesBySemester(sidebarContext.courses, GLOBAL_COURSE_CODE_NAMES)
    const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>({})

    const toggleGroup = (groupTitle: string) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupTitle]: !prev[groupTitle]
        }))
    }

    const renderCourseItem = (course: Course) => {
        const isSelected = course.name === sidebarContext.selectedCourse
        const displayName = formatCourseDisplayName(course.name, GLOBAL_COURSE_CODE_NAMES)

        return (
            <li key={course.name} style={{ listStyleType: 'none' }}>
                <div
                    className={`${styles.coursesListItemContainer} ${isSelected ? styles.selected : ''}`}
                    aria-label={displayName}
                >
                    <span
                        className={styles.coursesListItemText}
                        role="button"
                        onClick={() => {
                            handleSelectionChange(course.name)
                        }}
                    >
                        {displayName}{' '}
                    </span>
                    <div
                        className={styles.caretIcon}
                        role="button"
                        onClick={() => {
                            handleCaretClick(course.name)
                        }}
                        aria-label="expand course history"
                    >
                        {expandedCourse === course.name ? <CaretDownFilled /> : <CaretRightFilled />}
                    </div>
                </div>
                {<ChatHistoryList course={course} expanded={expandedCourse === course.name} />}
            </li>
        )
    }

    return (
        <div className={styles.coursesListContainer}>
            {globalCourses.length > 0 && (
                <ul className={styles.globalCoursesList} style={{ padding: 0, margin: 0 }}>
                    {globalCourses.map(renderCourseItem)}
                </ul>
            )}
            {groupedCourses.map(group => (
                <div key={group.title} className={styles.semesterGroup}>
                    <div 
                        className={styles.semesterHeader}
                        onClick={() => toggleGroup(group.title)}
                        role="button"
                        aria-expanded={!!expandedGroups[group.title]}
                    >
                        <span>{group.title}</span>
                        <div className={styles.groupCaretIcon}>
                            {expandedGroups[group.title] ? <CaretDownFilled /> : <CaretRightFilled />}
                        </div>
                    </div>
                    {expandedGroups[group.title] && (
                        <ul style={{ padding: 0, margin: 0 }}>
                            {group.courses.map(renderCourseItem)}
                        </ul>
                    )}
                </div>
            ))}
        </div>
    )
}

export default CoursesList
